// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"121":"gallery","177":"home","301":"test-erc4626","401":"appworks","714":"nft"}[chunkId] + "." + {"121":"d1059339","177":"f63d03e0","301":"54b794d8","401":"2ce709bc","714":"9472bf8b"}[chunkId] + ".chunk.css";
};